import { Typography } from '@material-ui/core';

export interface CompanyBranding {
  logoSrc: string;
  orgName: string;
}

export default function Branding({
  branding,
  maxHeight,
  maxWidth,
}: {
  branding: CompanyBranding;
  maxHeight?: number;
  maxWidth?: number;
}) {
  const { logoSrc, orgName } = branding;
  if (logoSrc) {
    return (
      <img
        src={logoSrc}
        className='logo'
        style={{
          maxHeight: maxHeight || 'auto',
          maxWidth: maxWidth || 'auto',
        }}
      />
    );
  }

  return <Typography variant='h1'>{orgName}</Typography>;
}
